<template>
  <div id="cancelmonthly">
    <Background />
    <h1>Subscriptions</h1>
    <div class="ml-24 mr-24 mt-4">
      <p>Lookup and cancel monthly subscriptions here by providing your existing subscription's information.</p>
      <p>Need help? Contact <b>{{ourEmail}}</b> </p>
    </div>
    <div id="form" class="">
      <div class="flex flex-col mt-4">
        <div class="my-2 flex-row">
          <label class="mr-2">Email</label>
          <input class="mr-4 input-text w-56" type="text"
            placeholder="user@host.com" v-model="email" />
        </div>

        <div class="my-2 flex-row">
          <div class="flex-col">
            <label>Card <i class="cc-img">.....</i> last4: </label>
            <input class="mr-4 input-text w-12" type="text"
              placeholder="XXXX" v-model="last4" />
          </div>
        </div>
        <div class="my-2 flex-row">
          <div class="flex-col">
            <label class="mr-2">Card expiration:</label>
            <input class="w-10 input-text" type="text"
              placeholder="MM" v-model="exp_month" />
              <span class="ml-2 mr-2">/</span>
            <input class="w-12 input-text" type="text"
              placeholder="YYYY" v-model="exp_year" />
          </div>
        </div>
      </div>
      <div class="group">
        <label></label>
        <div id="source-errors" role="alert" class="has-text-danger">
          <ul>
            <li :key="error.toString()" v-for="error in errors">{{ error }}</li>
          </ul>
        </div>
      </div>
      <div class="group">
        <label></label>
        <div id="source-success" role="note" class="has-text-success">{{success}}</div>
      </div>
      <div class="button-right m-4">
        <button class="btn-pill"
          v-bind:class="{ 'gray-pill': searching, 'orange-pill': !searching }"
          :disabled="searching" @click="searchCust" >{{searchCaption}}</button>
      </div>
      <div v-if="search_results" class="flex-center-container mt-8">
        <h1 class="mb-2">Search Results</h1>
        <p v-if="search_results.length === 0">No subscriptions matching this criteria were found.</p>
        <div :key="result.subscription_id" v-for="result in search_results" class="flex flex-initial items-center flex-row animate-hover-highlight">

          <div class="row-item">
            <div>{{result.product_name}}</div>
            <div>${{result.quantity * result.plan_amount / 100}} / month</div>
            </div>
          <div class="row-item">
            <button class="btn-pill orange-pill"
              v-bind:class="{ 'gray-pill': cancelling, 'orange-pill': !cancelling }"
              :disabled="cancelling" @click="stopCharges(result.subscription_id)">{{cancelCaption}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

$cc-img-url: url(./../assets/credit-card-regular.svg);

.cc-img {
  // @apply bg-black;
  // @apply text-white;
  @apply w-16;
  @apply h-12;
  @apply bg-white;
  mask-image: $cc-img-url;
  mask-repeat: no-repeat;
}

.input-text {
  @apply text-black;
}

.row-item {
  @apply mx-2;
  @apply my-2;
  @apply text-center;
}

</style>

<script>

import client from '../client/client'
import Background from './Background.vue'

export default {
  name: 'Subscriptions',
  data () {
    return {
      ourEmail: 'SojournEnid' + String.fromCharCode(0x40) + 'gmail' + '.com',
      searching: false,
      cancelling: false,
      errors: [],
      success: null,

      email: null,
      last4: null,
      exp_month: null,
      exp_year: null,

      search_results: null
    }
  },
  mounted() {
    /*
    if(localStorage.email) {
      this.email = localStorage.email
    }
    if(localStorage.last4) {
      this.last4 = localStorage.last4
    }
    if(localStorage.exp_month) {
      this.exp_month = localStorage.exp_month
    }
    if(localStorage.exp_year) {
      this.exp_year = localStorage.exp_year
    }
    */
  },
  watch: {
    /*
    email(newValue) {
      localStorage.email = newValue
    },
    last4(newValue) {
      localStorage.last4 = newValue
    },
    exp_month(newValue) {
      localStorage.exp_month = newValue
    },
    exp_year(newValue) {
      localStorage.exp_year = newValue
    }
    */
  },
  computed: {
    searchCaption: function () {
      return this.searching ? 'Searching...' : 'Search subscriptions'
    },
    cancelCaption: function () {
      return this.cancelling ? 'Wait...' : 'Stop recurring charge'
    }
  },
  components: {
    Background
  },
  methods: {
    clear () {
      this.errors = []
      this.success = null
    },
    async searchCust () {
      try {
        this.searching = true
        this.clear()

        if (!this.preSubmitValidate()) {
          this.searching = false
          return
        }

        let resps = await client.searchCustomersByCard({
          email: this.email,
          exp_month: this.exp_month,
          exp_year: this.exp_year,
          last4: this.last4
        })
        resps = this.mapSearchResults(resps)
        this.search_results = resps

      } catch(error) {
        this.errors.push(error)
      } finally {
        this.searching = false
      }
    },
    async stopCharges (subscriptionId) {
      let response = undefined
      try {
        this.cancelling = true
        this.clear()

        response = await client.removeSubscription(subscriptionId)
        // if no exception, then http status was 200 if(response.status === 200) {
        this.success = response.data.message || 'Success!'
      } catch(error) {
        this.errors.push('There was a problem cancelling a subscription. It might help to refresh the page and try again.')
      } finally {
        // this.searchCust()
        setTimeout(() => {
          this.search_results = this.search_results.filter((result) => {
            return result.subscription_id !== subscriptionId
          })
          this.cancelling = false
        }, 500)

      }
    },
    mapSearchResults(resps) {
      return resps.reduce((results, resp) => {
        let customer_record = {
          customer_id: resp.customer.id,
          email: this.email,
          exp_month: this.exp_month,
          exp_year: this.exp_year,
          last4: this.last4
        }
        resp.customer.subscriptions.data.map((subscr) => {
          let subscr_item = subscr.items.data[0]
          let subscr_record = {
            subscription_id: subscr.id,
            plan_amount: subscr_item.plan.amount,
            quantity: subscr_item.quantity,
            product_name: this.lookupProductName(subscr_item.plan.product, resp)
          }
          let returnMe = {
            ...customer_record,
            ...subscr_record
          }
          results.push(returnMe)
        })
        return results
      }, [])
    },
    lookupProductName(matchProductId, resp) {
      return resp.products.filter((product) => {
        return product.id === matchProductId
      })[0].name
    },
    preSubmitValidate () {
      let isValid = true

      if (!this.email) {
        this.errors.push(new Error('Email address required'))
        isValid = false
      }

      if(!this.last4) {
        this.errors.push(new Error("Card's last 4 digits are required"))
        isValid = false
      }

      return isValid
    }
  }
}

</script>
